import { createFileRoute, Outlet } from '@tanstack/react-router';

import { RequireCatalogImportComplete } from '~/features/onboarding/components/require-catalog-import-complete';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';
import { requireContract } from '~/utils/guards';

/**
 * Layout for the `/experiments/create` funnel. Children: `index` (channels
 * picker), `info` (disclaimer), `configure` (wizard). No chrome here — each
 * child page owns its own full-bleed layout. Experiments are Google-only
 * today, so `requireContract` redirects a TRIAL_POC (or unenrolled) Google
 * Ads tenant to `/product-not-enrolled` before any child route loads — see
 * docs/product-contract-route-guards.md. The stacked component gates then
 * cascade to every nested route via the shared <Outlet />:
 *   - `RequireChannelConnection`: a catalog source must be connected.
 *   - `RequireCatalogImportComplete`: that catalog must have finished
 *     importing (aggregate `catalogImportStatus === 'COMPLETE'`). Strict —
 *     resume-draft (`?expId=...`) is also blocked when status isn't COMPLETE.
 *     See `docs/experiment-create-import-gate.md`.
 */
export const Route = createFileRoute('/_authenticated/_tenant/experiments_/create')({
  beforeLoad: requireContract('google', ['LIVE']),
  component: () => (
    <RequireChannelConnection>
      <RequireCatalogImportComplete>
        <Outlet />
      </RequireCatalogImportComplete>
    </RequireChannelConnection>
  ),
});
